module.exports = __webpack_public_path__ + "img/portfolio--agency-04.9b2489b7.jpg";